import React from "react";
import styled from "styled-components";
import { noop } from "lodash";

import { SvgClose, SvgIconX } from "@/assets/icons";
import { RATypography } from "../Typography";
import { RAImage } from "../Image";

const getFileName = (url) => {
	const urls = url?.split("_") ?? [];
	return urls[urls.length - 1];
};

export const MessageContentFile = ({ icon, file, onClear = noop, isInput = false }) => {
	const truncate = {
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		width: 200,
	};

	const handleOpenFile = () => {
		if (!isInput) {
			window.open(file?.url, "_blank");
		}
	};

	return (
		<FileWrapper
			style={isInput ? { paddingTop: 12, paddingRight: 12 } : { cursor: "pointer" }}
			onClick={handleOpenFile}
		>
			<FileContent>
				<RAImage width="40px" height="40px" url={icon} />
				<div>
					<RATypography color="#0e0e12" style={isInput ? truncate : {}}>
						{file?.name ?? getFileName(file?.url)}
					</RATypography>
					<RATypography variant="label4" weight="medium" color="#65686F" top={2}>
						{`${(file?.size / 1000000).toFixed(2)}MB`}
					</RATypography>
				</div>
				{isInput && (
					<ClearWrapper onClick={onClear}>
						<SvgClose width="20" height="20" />
					</ClearWrapper>
				)}
			</FileContent>
		</FileWrapper>
	);
};

const FileWrapper = styled.div`
	position: relative;
`;

const FileContent = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	border-radius: 8px;
	border: 1px solid #e5e7eb;
	padding: 12px;
	height: 56px;
	width: fit-content;
	min-width: 220px;
`;

const ClearWrapper = styled.div`
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 100px;
	cursor: pointer;
`;
